module.exports = __webpack_public_path__ + "static/media/Steve Wangen.ce96f88c.jpg";